import { connect } from 'react-redux'
import { selectAccountUrl, selectAutoLoginUrl } from 'selectors/app'
import { doSetOnboardingCompleteFlag } from 'subapps/onboarding/actions'
import CompletionPageView from './view'

const select = state => ({
  accountUrl: selectAccountUrl(state),
  autoLoginUrl: selectAutoLoginUrl(state),
})

const perform = {
  setCompleteFlag: doSetOnboardingCompleteFlag,
}

export default connect(select, perform)(CompletionPageView)
